/**
 * CTAModal, final tour CTA (Sign Up / Guest Preview).
 * Extracted from PlatformTour.js (Phase 3 refactor, 2026-05-03).
 */
import React from "react";
import { Rocket } from "lucide-react";
import { IsaiahMascotCore } from "../isaiah";

export const CTAModal = ({ onDismiss, onSignUp, onGuestPreview }) => (
  <div className="fixed inset-0 z-[10002] flex items-center justify-center p-4">
    <div className="absolute inset-0 bg-black/70" onClick={onDismiss} />
    <div
      className="relative rounded-3xl p-8 max-w-md w-full border-2 border-purple-400/30 text-center"
      style={{
        background: "linear-gradient(135deg, rgba(30,20,60,0.95), rgba(20,15,50,0.95))",
        boxShadow: "0 0 60px rgba(139,92,246,0.2)",
      }}
    >
      <div className="flex justify-center mb-4">
        <IsaiahMascotCore
          pose="celebrating"
          size="icon"
          style={{ width: 64, height: 80 }}
          testId="tour-cta-isaiah"
        />
      </div>
      <h2
        className="text-2xl font-fredoka font-bold text-white mb-2"
        style={{ textShadow: "0 2px 10px rgba(0,0,0,0.3)" }}
      >
        Ready to Join the Universe?
      </h2>
      <p className="text-white/55 text-sm font-nunito mb-6 leading-relaxed">
        Create your free Explorer profile and start learning, playing, and creating today! No credit card needed.
      </p>
      <div className="flex flex-col gap-3">
        <button
          onClick={onSignUp}
          className="w-full py-3.5 rounded-xl font-fredoka font-bold text-sm text-white transition-all hover:scale-[1.02] shadow-lg shadow-purple-500/25"
          style={{ background: "linear-gradient(135deg, #3B82F6, #8B5CF6, #EC4899)" }}
          data-testid="tour-cta-signup"
        >
          <Rocket size={16} className="inline mr-2" />
          Sign Up Now
        </button>
      </div>
    </div>
  </div>
);
